/**
 * Mix tab — product mix breakdown (by product · by branch · by type).
 */

import { KpiTile, Pill } from '@/components/primitives';
import type { RrmFilters } from './types';

export interface MixTabProps {
  filters: RrmFilters;
}

export function MixTab({ filters: _filters }: MixTabProps): JSX.Element {
  return (
    <>
      <div className="rrm-kpi-strip">
        <KpiTile label="DDA share" value="52%" />
        <KpiTile label="Savings share" value="20%" severity="balance" />
        <KpiTile label="CD share" value="16%" severity="cust" />
        <KpiTile label="IRA share" value="6%" severity="rev" />
      </div>

      <article className="rrm-chart-card">
        <header className="rrm-chart-header">
          <div>
            <div className="rrm-chart-title">Product mix trend</div>
            <div className="rrm-chart-sub">Share of total opened accounts · 12-month rolling</div>
          </div>
        </header>
        <div className="rrm-chart-body">
          <p style={{ color: 'var(--ink-600)' }}>
            Stacked area chart ships Wave 3. Data source: <code>MetricsDaily</code> aggregated by product.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 'var(--sp-4)', marginTop: 'var(--sp-7)' }}>
            {[
              ['DDA', '162', 'ok'],
              ['SAV', '62', 'info'],
              ['CD', '51', 'ok'],
              ['IRA', '18', 'warn'],
              ['SDB', '11', 'info'],
              ['Biz', '8', 'info'],
            ].map(([label, count, variant]) => (
              <div key={label} style={{ background: 'var(--ink-50)', padding: 'var(--sp-5)', borderRadius: 'var(--r-sm)' }}>
                <div style={{ fontSize: 11, color: 'var(--ink-600)', textTransform: 'uppercase', fontWeight: 700 }}>{label}</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: 'var(--pcb-blue-dark)', marginTop: 4 }}>{count}</div>
                <Pill variant={variant as 'ok' | 'info' | 'warn'}>MTD</Pill>
              </div>
            ))}
          </div>
        </div>
      </article>
    </>
  );
}
